import { TCoordinates } from 'views/report/types.ts';
import { TAddTitleOptions } from 'views/report/utils/add-title/types.ts';
import { blackColor } from 'views/report/colors.ts';
import { fontBold, fontMainSize } from 'views/report/utils/style-consts.ts';

export const addTitle = (doc: any, title: string, options: TAddTitleOptions): TCoordinates => {
  const { x, y, fontSize = fontMainSize, font = fontBold } = options;

  doc.setTextColor(blackColor);
  doc.setFont(font.fontName, font.fontStyle);
  doc.setFontSize(fontSize);

  doc.text(title, x, y);

  return { x, y };
};
